module.exports = __webpack_public_path__ + "img/sii-icon-active.85198912.svg";